var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#DABEEA"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M201.5 1730c9.113 0 16.5 7.387 16.5 16.5s-7.387 16.5-16.5 16.5-16.5-7.387-16.5-16.5 7.387-16.5 16.5-16.5zm.443 5.363c-.496-.245-1.095-.041-1.34.454l-2.777 5.627-6.209.902c-.218.032-.419.134-.572.292-.386.395-.378 1.028.018 1.414l4.493 4.38-1.06 6.184c-.038.216-.003.44.1.634.257.489.861.677 1.35.42l5.554-2.92 5.554 2.92c.195.102.417.137.634.1.545-.093.91-.61.817-1.154l-1.06-6.185 4.492-4.38c.158-.153.26-.354.292-.572.08-.546-.3-1.054-.846-1.133l-6.21-.902-2.776-5.627c-.098-.197-.257-.357-.454-.454z",
    transform: "translate(-185 -1730)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.9abd0776ab8e266bfa8647db63de2dac.svg";
export { ForwardRef as ReactComponent };